// Import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode, EffectFade } from 'swiper/modules';

// Import GSAP and its plugins
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import GSDevTools from "gsap/GSDevTools";
import CustomEase from 'gsap/CustomEase'

// Import smooth scrolling functionality
import { lenis, smoothScrolling } from './misc.js';


function homepage3(){
    // Uncomment for GSAP development tools
    //GSDevTools.create();

    // Initialize smooth scrolling if not already done
    if (!lenis) {
        smoothScrolling();
    }

    // Get main sections container
    const homepage3 = document.querySelector('[data-name="homepage_3"]');
    if (!homepage3) return;

    // Fade in the body
    gsap.to(document.body, { opacity: 1, duration: 1, ease: "power1.out" });

    // Scroll to top using lenis for smooth scrolling
    lenis.scrollTo(0, { immediate: true });

   
    
} 

export { homepage3 }